<div class="inline-block tag-button-container" data-testid="tag-button-container">
  <button
    class="ps-xsmall-x"
    [class.tag-button]="SiteTheme === FinnairTheme.LEGACY"
    [class.tag-default]="SiteTheme === FinnairTheme.LEGACY && computedTheme() === ChipTheme.DEFAULT"
    [class.tag-active]="SiteTheme === FinnairTheme.LEGACY && computedTheme() === ChipTheme.ACTIVE"
    [class.tag-popular]="SiteTheme === FinnairTheme.LEGACY && computedTheme() === ChipTheme.POPULAR"
    [class.tag-light]="SiteTheme === FinnairTheme.LEGACY && computedTheme() === ChipTheme.LIGHT"
    [class.chip-button]="SiteTheme !== FinnairTheme.LEGACY"
    [class.default]="SiteTheme !== FinnairTheme.LEGACY && computedTheme() === ChipTheme.DEFAULT"
    [class.active]="SiteTheme !== FinnairTheme.LEGACY && computedTheme() === ChipTheme.ACTIVE"
    [attr.aria-label]="title()"
    [attr.title]="title()"
    [disabled]="disabled()"
    (blur)="blur.emit($event)"
    (click)="tagClicked.emit($event)"
  >
    @if (!text()) {
      <ng-content />
    }
    @if (text()) {
      <span class="ps-xxsmall-y flex flex--center">
        <span class="regular-type font-body-medium">{{ text() }}</span>
        @if (iconName()) {
          <fcom-icon [category]="iconCategory()" [name]="iconName()" class="icon-small ps-xxsmall-l" />
        }
      </span>
    }
  </button>
</div>
